import React from 'react'
import { DatePicker as DatePickerAntd } from 'antd'

class DatePicker extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      focused: false,
    }
    this.dateChanged = this.dateChanged.bind(this)
  }

  dateChanged() {
    const { setDate, onChange } = this.props
    setDate(...arguments)
    if (onChange) onChange(...arguments)
  }

  render() {
    const { date, dateProps = {} } = this.props

    return (
      <DatePickerAntd
        id="date_input"
        value={date}
        onChange={this.dateChanged}
        format="MM/DD/YYYY"
        showToday={false}
        {...dateProps}
      />
    )
  }
}

export default DatePicker
